module.exports = __webpack_public_path__ + "static/media/mem8YaGs126MiZpBA-UFUZ0bbck.0c4fa4c6.woff2";